import { Button, ListItemText, Menu, MenuItem } from "@mui/material";
import { FMFile } from "../shared/FMFile";
import { DeleteOutline, EditOutlined, InfoOutlined, PreviewOutlined, ShareOutlined } from "@mui/icons-material";
import { useRef, useState } from "react";

export default function SelectionMenu(props:{files:FMFile[],onDelete:any,onPreview:any,onShare:any}) {
    const [share,setShare] = useState<boolean>(false)
    const {files} = props
    const shareRef = useRef<any>()
    const preview = files.length==1 ? <Button startIcon={<PreviewOutlined/>} onClick={e=>props.onPreview(files[0])}>Preview</Button> : null
    const onShare = (duration:number) => () => {
        setShare(false)
        props.onShare(files, duration)
    }    
    const onShareClick = () => setShare(share => !share)
    const shareMenu = share ? <Menu onClose={e => setShare(false)} open={share} anchorEl={shareRef.current}>
        <MenuItem onClick={onShare(5)}><ListItemText>5 minutes</ListItemText></MenuItem>
        <MenuItem onClick={onShare(10)}><ListItemText>10 minutes</ListItemText></MenuItem>
        <MenuItem onClick={onShare(60)}><ListItemText>1 hour</ListItemText></MenuItem>
        <MenuItem onClick={onShare(24*60)}><ListItemText>1 day</ListItemText></MenuItem>
    </Menu> : null
    const rename = files.length==1 ? <Button startIcon={<EditOutlined/>}>Rename</Button> : null
    return <div className="selectionMenu flex gap-16 wrap">
        {preview}
        <Button startIcon={<ShareOutlined/>} ref={shareRef} onClick={onShareClick}>Share</Button>
        {shareMenu}
        {rename}
        <Button startIcon={<DeleteOutline/>} onClick={e=>props.onDelete(files)}>Delete</Button>
        <Button startIcon={<InfoOutlined/>}>Properties</Button>
    </div>
}